import addStartupScript from './events/addStartupScript';
import addTargetEventListener from './events/addTargetEventListener';
import toggleClass from './elements/toggleClass';

export function setupBackLink() {
  const backLink = document.querySelector('.right-image-hero-back');

  // return if no backLink element, or if document.referrer is blank
  if (!backLink || !document.referrer) {
    return;
  }

  // show link if referrer is same site
  if (document.referrer.indexOf(window.location.host) != -1) {
    toggleClass(backLink, 'hidden', false);
  }
}

export function handleClick(event) {
  event.preventDefault();
  window.history.back();
}

addStartupScript(setupBackLink);
addTargetEventListener('click', '.js-previous-page', handleClick);
